export default "__VITE_PUBLIC_ASSET__cfd77cdb__"